import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { AverageExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/AverageExpression";

export class AverageExpressionEditor extends ExpressionRuleEditor<AverageExpression> {
    render() {
        return (
            <ExpressionPiece>
                average
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
